if (!window.__productFeedInitialized) {
  window.__productFeedInitialized = true;

  document.addEventListener("DOMContentLoaded", () => {
    initProductFeedCarousels();
    bindProductFeedResize();
  });

  function shouldEnableCarousel() {
    return window.innerWidth > 991;
  }

  function initProductFeedCarousels(scope = document) {
    scope.querySelectorAll(".js-products-carousel").forEach((element) => {
      if (!shouldEnableCarousel()) {
        destroySingleCarousel(element);
        return;
      }

      if (element.__splideInstance) return;

      const splide = new Splide(element, {
        type: "slide",
        drag: true,
        gap: "16px",
        perPage: 4,
        rewind: false,
        arrows: false,
        pagination: false,
        breakpoints: {
          1298: {
            perPage: 3,
            gap: "16px",
          },
          1440: {
            perPage: 4,
            gap: "16px",
          },
        },
      });

      splide.mount();
      element.__splideInstance = splide;
      if (typeof window.enableSplideWheelNav === "function") {
        window.enableSplideWheelNav(splide, element);
      }
    });
  }

  function destroySingleCarousel(element) {
    if (element.__splideInstance) {
      element.__splideInstance.destroy(true);
      element.__splideInstance = null;
    }
  }

  function destroyProductFeedCarousels(scope = document) {
    scope.querySelectorAll(".js-products-carousel").forEach((element) => {
      destroySingleCarousel(element);
    });
  }

  function bindProductFeedResize() {
    let resizeTimer;

    window.addEventListener("resize", () => {
      clearTimeout(resizeTimer);

      resizeTimer = setTimeout(() => {
        document.querySelectorAll(".js-products-carousel").forEach((element) => {
          if (shouldEnableCarousel()) {
            if (!element.__splideInstance) {
              initProductFeedCarousels(element.parentNode || document);
            }
          } else {
            destroySingleCarousel(element);
          }
        });
      }, 150);
    });
  }

  if (typeof Shopify !== "undefined" && Shopify.designMode) {
    document.addEventListener("shopify:section:load", (event) => {
      const section = event.target;
      destroyProductFeedCarousels(section);
      initProductFeedCarousels(section);
    });

    document.addEventListener("shopify:section:unload", (event) => {
      destroyProductFeedCarousels(event.target);
    });

    document.addEventListener("shopify:section:select", (event) => {
      const section = event.target;
      destroyProductFeedCarousels(section);
      initProductFeedCarousels(section);
    });

    document.addEventListener("shopify:section:deselect", (event) => {
      const section = event.target;
      destroyProductFeedCarousels(section);
      initProductFeedCarousels(section);
    });
  }
}